import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const MarketingResources = ({
  isIconSmall,
  ...props
}: {
  isIconSmall?: boolean
}) => {
  if (isIconSmall) {
    return (
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={29}
        height={29}
        fill="none"
        {...props}
      >
        <G
          clipPath="url(#a)"
          style={{
            mixBlendMode: 'luminosity',
          }}
        >
          <Mask
            id="b"
            width={29}
            height={29}
            x={0}
            y={0}
            maskUnits="userSpaceOnUse"
            style={{
              maskType: 'luminance',
            }}
          >
            <Path
              fill="#fff"
              d="M23.662.808H4.994A4.667 4.667 0 0 0 .328 5.474v18.667a4.667 4.667 0 0 0 4.667 4.667h18.667a4.667 4.667 0 0 0 4.666-4.667V5.474A4.667 4.667 0 0 0 23.662.808Z"
            />
          </Mask>
          <G mask="url(#b)">
            <Path
              fill="#F2F7FF"
              d="M23.662.808H4.994A4.667 4.667 0 0 0 .328 5.474v18.667a4.667 4.667 0 0 0 4.667 4.667h18.667a4.667 4.667 0 0 0 4.666-4.667V5.474A4.667 4.667 0 0 0 23.662.808Z"
            />
            <Path
              fill="url(#c)"
              d="m9.953 14.516 1.942-1.941a2.333 2.333 0 0 1 1.65-.684h7.783a2.333 2.333 0 0 1 2.334 2.333v8.75a2.333 2.333 0 0 1-2.334 2.334H9.661a2.333 2.333 0 0 1-2.333-2.334v-4.866c0-.62.246-1.213.684-1.65l1.941-1.942Z"
            />
            <Path
              fill="#F2F7FF"
              d="M21.328 18.891H9.661a.583.583 0 0 0-.583.583v.584c0 .322.261.583.583.583h11.667a.583.583 0 0 0 .584-.583v-.584a.583.583 0 0 0-.584-.583Z"
            />
            <Path
              fill="url(#d)"
              d="M19.11 19.405H7.279a2.333 2.333 0 0 0-2.334 2.334v7.72a2.333 2.333 0 0 0 2.334 2.334h11.83a2.333 2.333 0 0 0 2.334-2.334v-7.72a2.333 2.333 0 0 0-2.333-2.334Z"
            />
            <Path
              fill="#F2F7FF"
              d="M15.64 25.107c.36.23.36.755 0 .984l-3.61 2.297a.583.583 0 0 1-.897-.492v-4.594c0-.46.508-.74.896-.492l3.611 2.297ZM21.33 15.39h-7.583a.583.583 0 0 0-.583.584v.583c0 .323.261.584.583.584h7.584a.583.583 0 0 0 .583-.584v-.583a.583.583 0 0 0-.583-.583Z"
            />
            <Path fill="#C9A678" d="m7.328 17.141 5.25-5.25v5.25h-5.25Z" />
          </G>
        </G>
        <Defs>
          <RadialGradient
            id="c"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-14.35945 12.57518 -10.88688 -12.4316 21.078 12.691)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <RadialGradient
            id="d"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(141.155 6.53 13.665) scale(17.8859 16.2506)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <ClipPath id="a">
            <Path fill="#fff" d="M.328.808h28v28h-28z" />
          </ClipPath>
        </Defs>
      </Svg>
    )
  }
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_4356_306)">
        <Mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={48}
          height={48}
        >
          <Path
            d="M40 0H8a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V8a8 8 0 00-8-8z"
            fill="#fff"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M40 0H8a8 8 0 00-8 8v32a8 8 0 008 8h32a8 8 0 008-8V8a8 8 0 00-8-8z"
            fill="#F2F7FF"
          />
          <Path
            d="M16.5 23.5l3.328-3.328A4 4 0 0122.657 19H36a4 4 0 014 4v15a4 4 0 01-4 4H16a4 4 0 01-4-4v-8.343a4 4 0 011.172-2.829L16.5 23.5z"
            fill="url(#paint0_radial_4356_306)"
          />
          <Path
            d="M36 31H16a1 1 0 00-1 1v1a1 1 0 001 1h20a1 1 0 001-1v-1a1 1 0 00-1-1z"
            fill="#F2F7FF"
          />
          <Path
            d="M32.196 31.883H11.914a4 4 0 00-4 4v13.235a4 4 0 004 4h20.282a4 4 0 004-4V35.883a4 4 0 00-4-4z"
            fill="url(#paint1_radial_4356_306)"
          />
          <Path
            d="M26.243 41.656a1 1 0 010 1.688l-6.19 3.937a1 1 0 01-1.537-.843v-7.876a1 1 0 011.536-.844l6.19 3.938zM36 25H23a1 1 0 00-1 1v1a1 1 0 001 1h13a1 1 0 001-1v-1a1 1 0 00-1-1z"
            fill="#F2F7FF"
          />
          <Path d="M12 28l9-9v9h-9z" fill="#C9A678" />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_4356_306"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-24.61623 21.55747 -18.66327 -21.31138 35.571 20.372)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_4356_306"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-23.88065 19.23144 -17.47304 -21.69716 34.044 33.265)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <ClipPath id="clip0_4356_306">
          <Path fill="#fff" d="M0 0H48V48H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default MarketingResources
